import { TestBed } from '@angular/core/testing';
import { FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { MsgService } from '../msg/msg.service';
import { UtilService } from '../util/util.service';
import * as MSG from '../msg/msg';
import { REGEXP } from '../../share/validation/regexp';
import { Mode } from '../../share/enums-master';
declare var $;

@Injectable()
export class ValidationService {
  /** Validation結果。有効値ならfalse, 無効値ならtrue。DIしたcomponentから操作もされる。 */
  validationInvalid = false;
  renderDuplicateMessage = {};

  constructor(
    private msgServ: MsgService,
    private utilServ: UtilService,
  ) { }
/**
 * 事前定義したAngularデフォルトのValidationを実施。
 * @param {FormControl} formControl FormControl
 * @param {string} formLabel フォーム名(トースター表示に使用)
 * @return {boolean} 検証を通過した場合trueを返す
*/
  public formValidation(formControl: any, formLabel?: string): boolean {
    let isValidReturnValue = true;
    if (formControl.dirty && formControl.errors !== null) {
      // 空白禁止
      if ('required' in formControl.errors) {
        this.msgServ.warning(MSG.WARNING.BLANK(formLabel), '');
        this.validationInvalid = true;
        isValidReturnValue = false;
      }
      // 文字数が(number)文字以上か
      if ('minlength' in formControl.errors) {
        this.msgServ.warning(MSG.WARNING.STRING_LENGTH_SMALL(formLabel, formControl.errors.minlength.requiredLength), '');
        this.validationInvalid = true;
        isValidReturnValue = false;
      }
      // 文字数が(number)文字以下か
      if ('maxlength' in formControl.errors) {
        this.msgServ.warning(MSG.WARNING.STRING_LENGTH_LARGE(formLabel, formControl.errors.maxlength.requiredLength), '');
        this.validationInvalid = true;
        isValidReturnValue = false;
      }
      // 数値が(number)以上か
      if ('min' in formControl.errors) {
        this.msgServ.warning(MSG.WARNING.NUMBER_SMALL(formLabel, formControl.errors.min.min), '');
        this.validationInvalid = true;
        isValidReturnValue = false;
      }
      // 数値が(number)以下か
      if ('max' in formControl.errors) {
        this.msgServ.warning(MSG.WARNING.NUMBER_LARGE(formLabel, formControl.errors.max.max), '');
        this.validationInvalid = true;
        isValidReturnValue = false;
      }
      // 正規表現での判定( 正規表現の式は regexp.ts 参照 )
      if ('pattern' in formControl.errors) {
        switch (formControl.errors.pattern.requiredPattern) {
          // 郵便番号の形式か
          case String(REGEXP.POSTCODE):
            this.msgServ.warning(MSG.WARNING.NOT_POSTCODE, '');
            this.validationInvalid = true;
            isValidReturnValue = false;
            break;
          // 電話番号の形式か
          case String(REGEXP.TEL):
            this.msgServ.warning(MSG.WARNING.NOT_TEL(formLabel), '');
            this.validationInvalid = true;
            isValidReturnValue = false;
            break;
          // FAX番号の形式か
          case String(REGEXP.FAX):
            this.msgServ.warning(MSG.WARNING.NOT_FAX(formLabel), '');
            this.validationInvalid = true;
            isValidReturnValue = false;
            break;
          // 半角英数か
          case String(REGEXP.HALF_WIDTH_CHAR):
            this.msgServ.warning(MSG.WARNING.NOT_HALF_WIDTH_CHAR(formLabel), '');
            this.validationInvalid = true;
            isValidReturnValue = false;
            break;
          // 半角英数か
          case String(REGEXP.HALF_WIDTH_CHAR_UNDERSCORE_HYPHEN):
            this.msgServ.warning(MSG.WARNING.NOT_HALF_WIDTH_CHAR(formLabel), '');
            this.validationInvalid = true;
            isValidReturnValue = false;
            break;
          // 半角英数か
          case String(REGEXP.HALF_WIDTH_CHAR_UNDERSCORE):
            this.msgServ.warning(MSG.WARNING.NOT_HALF_WIDTH_CHAR_UNDERSCORE(formLabel), '');
            this.validationInvalid = true;
            isValidReturnValue = false;
            break;
          // パスワードの形式か
          case String(REGEXP.PASSWORD):
            this.msgServ.warning(MSG.WARNING.NOT_PASSWORD, '');
            this.validationInvalid = true;
            isValidReturnValue = false;
            break;
          // 半角数字のみか
          case String(REGEXP.ONLY_NUMBER):
            this.msgServ.warning(MSG.WARNING.NOT_NUMBER(formLabel), '');
            this.validationInvalid = true;
            isValidReturnValue = false;
            break;
        }
      }
      // メールアドレスの形式か
      if ('email' in formControl.errors) {
        this.msgServ.warning(MSG.WARNING.NOT_MAIL, '');
        this.validationInvalid = true;
        isValidReturnValue = false;
      }
    }
    return isValidReturnValue;
  }

  /*===============================================================================================
   以下に必要に応じて、オリジナルのValidation用メソッドを定義。

     * component.htmlのformタグにイベントバインディングとして設定。

     * Validationの条件はメソッドの引数で渡す。
       また、トースター表示用に、formControlとformLabelも引数で渡す。

       (例) (blur)="this.validationServ.numRangeValidation(1, 7, detailDealercode, '詳細：ディーラーCD')
  ===============================================================================================*/

  /** 桁数が 1 〜 (number) 以下のみ許可(null(フォーム未入力)は許可する) */
  public numOfDigitsMinValidation(number: number, formControl: any, formLabel: string): boolean {
    let isValidReturnValue = true;
    if (formControl.value != null &&
        !new RegExp('^\\d*$').test(formControl.value) ||
        String(formControl.value).length > number) {
      formControl.status = 'INVALID';
      this.msgServ.warning(MSG.WARNING.NUMBER_OF_DIGITS_LARGE(formLabel, number), '');
      this.validationInvalid = true;
      isValidReturnValue = false;
    }
    return isValidReturnValue;
  }

  /** 数字が (number1) 〜 (number2) の範囲のみ許可 */
  public numRangeValidation(number1: number, number2: number, formControl: any, formLabel: string): boolean {
    let isValidReturnValue = true;
    if (formControl.value < number1 || formControl.value > number2) {
      formControl.status = 'INVALID';
      this.msgServ.warning(MSG.WARNING.NUMBER_RANGE_OVER(formLabel, number1, number2), '');
      this.validationInvalid = true;
      isValidReturnValue = false;
    }
    return isValidReturnValue;
  }

  /** 文字数が (number1) 〜 (number2)文字 の範囲のみ許可 */
  public stringRangeValidation(number1: number, number2: number, formControl: any, formLabel: string): boolean {
    let isValidReturnValue = true;
    if (String(formControl.value).length < number1 || String(formControl.value).length > number2) {
      formControl.status = 'INVALID';
      this.msgServ.warning(MSG.WARNING.STRING_LENGTH_RANGE_OVER(formLabel, number1, number2), '');
      this.validationInvalid = true;
      isValidReturnValue = false;
    }
    return isValidReturnValue;
  }

  /** [wijmoフォーム専用] 値が一意制約を守っている場合許可。primary keyが複数ある場合は、事前にgridDataをソートしておく。
   * @param {any[]} gridData グリッド配列
   * @param {string} gridColomnName グリッドのカラム名(テーブル定義上のカラム名を同じ)
   * @param {string} attr 検証対象となるフォームのテンプレート上のid名
   * @param {any} wjControl 検証対象となるフォームのプロパティ名
   * @param {string} formLabel トースターに表示するフォーム名
   */
  public wUnique(
    gridData: any[],
    gridColomnName: string,
    attr: string,
    currentMode: Mode,
    wjControl: any,
    formLabel?: string,
    option: {validateColomn: string, validateValue: number} = null
  ): boolean {
    let isValidReturnValue = true;
    if (currentMode !== Mode.postMode && currentMode !== Mode.copyMode) {
      return true;
    }
    let rowFinded = gridData.find(gridRecord => {
      return gridRecord[gridColomnName] === wjControl.value;
    });
    if (rowFinded && option) {
      if (rowFinded[option.validateColomn] !== option.validateValue) {
        rowFinded = null;
      }
    }
    if (rowFinded) {
      $('#' + attr).addClass('wj-unique-invalid');
      this.msgServ.warning(MSG.DANGER.S409_CONFLICT, '');
      this.validationInvalid = true;
      isValidReturnValue = false;
    } else {
      $('#' + attr).removeClass('wj-unique-invalid');
    }
    return isValidReturnValue;
  }
  /** [wijmoフォーム専用] 値が一意制約を守っている場合許可。primary keyが複数ある場合専用。]
   * @param checkValues 入力フォームの情報
   * @param checkColomns pkとなるグリッドのカラム名
   * @param gridData グリッド配列
   * @param attr HTMLのID名
   * @param currentMode 現在のモード
   */
  public wUniqueInPrimaryKeys(
    checkValues: {colomn: string, value: any}[],
    checkColomns: string[],
    gridData: any[],
    attr: string,
    currentMode: Mode,
  ): boolean {
    let isValidReturnValue = true;
    if (currentMode !== Mode.postMode && currentMode !== Mode.copyMode) {
      return true;
    }

    gridData.forEach(record => {
      let equalsColomn = 0;
      checkColomns.forEach(checkColomn => {
        const inputForm = checkValues.find(val => val.colomn === checkColomn);
        if (record[checkColomn] === inputForm.value) {
          equalsColomn++;
        }
      });
      // 全てのpkカラムの値において重複した
      if (checkColomns.length === equalsColomn) {
        this.validationInvalid = true;
        isValidReturnValue = false;
      }
    });

    if (!isValidReturnValue) {
      $('#' + attr).addClass('wj-unique-invalid');
      this.msgServ.warning(MSG.DANGER.S409_CONFLICT, '');
    } else {
      $('#' + attr).removeClass('wj-unique-invalid');
    }
    return isValidReturnValue;
  }

  /** 値が一意制約を守っている場合許可 */
  public ngUnique(
    grid: any,
    propName: string,
    attr: string,
    currentMode: Mode,
    wjControl: any,
    formLabel?: string,
    option: {validateColomn: string, validateValue: number} = null
  ): boolean {
    let isValidReturnValue = true;
    // 新規モード時以外は検証しない
    if (currentMode !== Mode.postMode && currentMode !== Mode.copyMode) {
      return true;
    }
    // wijmoGridのproperty内に同一のvalueがあればtrueを返す
    let rowFinded = grid.find(gridRecord => {
      return gridRecord[propName] === wjControl.value;
    });
    if (rowFinded && option) {
      if (rowFinded[option.validateColomn] !== option.validateValue) {
        rowFinded = null;
      }
    }
    if (rowFinded) {
      this.msgServ.warning(MSG.DANGER.S409_CONFLICT, '');
      this.validationInvalid = true;
      isValidReturnValue = false;
    }
    return isValidReturnValue;
  }
  /** 配列の中で値が一意制約を守っている場合許可 */
  public ngUniqueInArray(
    array: any[], checkObj: any, checkProp: string, attr: string, index: number, formLabel: string
  ): boolean {
    let isValidReturnValue = true;
    array = array.filter((value, i) => {
      return i !== index;
    });
    const notUnique: boolean = array.some((obj) => {
      return obj[checkProp]['value'] === checkObj[checkProp]['value'];
    });

    // formControl配列に同値があった時
    if (notUnique) {
      $(attr + index).addClass('wj-unique-invalid');
      if (!this.renderDuplicateMessage[checkProp]) {
        this.msgServ.warning(MSG.WARNING.DUPLICATE(formLabel), '');
        this.renderDuplicateMessage[checkProp] = true;
      }
      this.validationInvalid = true;
      isValidReturnValue = false;
    } else {
      $(attr + index).removeClass('wj-unique-invalid');
    }
    return isValidReturnValue;
  }
  /** [wijmoフォーム専用] 値が一意制約を守っている場合許可(複数の値の組み合わせを比較する場合) */
  public wComboUnique(
    wijmoGrid: any, propName: string[], attr: string[], currentMode: string, wjControl: any[], formLabel?: string
  ): boolean {
    let isValidReturnValue = true;
    // 新規モード時以外は検証しない
    if (currentMode !== 'postMode') {
      return isValidReturnValue;
    }
    // wijmoGridのproperty内に同一のvalueがあればtrueをresult配列に追加。
    let result: boolean;
    let notUnique = 0;
    for (let i = 0; i < wjControl.length; i++) {
      result = wijmoGrid._view.some(function(value) {
        return value[propName[i]] === wjControl[i].value;
      });
      if (result) {
        notUnique++;
      }
    }
    // wjControl配列と同じ組み合わせのデータがあった時
    if (notUnique === wjControl.length) {
      for (let i = 0; i < wjControl.length; i++) {
        $(attr[i]).addClass('wj-unique-invalid');
      }
      this.msgServ.warning(MSG.DANGER.S409_CONFLICT, '');
      this.validationInvalid = true;
      isValidReturnValue = false;
    } else {
      for (let i = 0; i < wjControl.length; i++) {
        $(attr[i]).removeClass('wj-unique-invalid');
      }
    }
    return isValidReturnValue;
  }
  /** [wijmoフォーム専用] 値が一意制約を守っている場合許可 (トースター表示無し、フォーム色変えない) */
  public wUniqueNoWarnMsg(wijmoGrid, property, wjControl): boolean {
    // wijmoGridのproperty内に同一のvalueがあればtrueを返す
    const result = wijmoGrid._view.some(function(value) {
      return value[property] === wjControl.value;
    });
    return result;
  }

  /** [wijmoフォーム専用] 空白以外を許可
   * @param {string} attr テンプレート上のid名
   * @param {any} wjControl wijmoControlオブジェクト
   * @param {string} formLabel formLabel。エラーメッセージに使用。
   * @param {string} type 'Date': wjInputDateの場合に付与, 'none': wjControl.valueが存在しない場合等に指定
   * @param {string} warnMsg 'notExist': validation結果がinvalidだった場合のエラーメッセージ種類。defaultはMSG.WARNING.BLANK(formLabel)
   * @returns {boolean} 結果がinvalidの場合、false
   */
  public wRequireValidation(attr: string, wjControl: any, formLabel: string, type?: 'Date' | 'none', warnMsg?: string): boolean {
    let isValidReturnValue = true;
    let wjValue;

    // フォーム用オブジェクトから値を取得
    if (type === 'Date' || type === 'none') {
      wjValue = wjControl;
    } else {
      wjValue = wjControl.value;
    }

    // 未入力の値だった場合、警告処理を実施
    if (wjValue === '' || wjValue === null || wjValue === -1) {
      this.validationInvalid = true;
      isValidReturnValue = false;
      // ID未指定の場合は警告非表示
      if (attr === null) {
        return isValidReturnValue;
      }
      // HTML要素の指定IDを警告用スタイルにする
      $('#' + attr).addClass('wj-require-invalid');
      if (warnMsg === 'notExist') {
        this.msgServ.warning(MSG.WARNING.NOT_EXIST_DATA(formLabel), '');
      } else {
        this.msgServ.warning(MSG.WARNING.BLANK(formLabel), '');
      }
    } else {
      // HTML要素の指定IDから警告用スタイルを除去
      $('#' + attr).removeClass('wj-require-invalid');
    }
    return isValidReturnValue;
  }

  /** [wijmoフォーム専用] 配列のうち、空白以外が１つ以上あれば許可 */
  public wRequireAtLeastOnce(attr: string[], wjControl: any[], formLabel: string): boolean {
    let isValidReturnValue = true;
    let exist = 0;
    for (const wj of wjControl) {
      if (wj.value !== '' && wj.value !== null) {
        exist++;
      }
    }
    // wjControl配列のうち、空白以外が１つ以上あった時
    if (exist === 0) {
      for (let i = 0; i < wjControl.length; i++) {
        $(attr[i]).addClass('wj-require-invalid');
      }
      this.msgServ.warning(MSG.WARNING.BLANK(formLabel), '');
      this.validationInvalid = true;
      isValidReturnValue = false;
    } else {
      for (let i = 0; i < wjControl.length; i++) {
        $(attr[i]).removeClass('wj-require-invalid');
      }
    }
    return isValidReturnValue;
  }

  /** [wijmoフォーム専用] 郵便番号のみ許可
   * @param {boolean} judgeBlank 空白を禁止するか
   */
  public wRegexpPostcode(attr: string, wjControl: any, judgeBlank: boolean = true): boolean {
    let isValidReturnValue = true;
    if (!wjControl.value) {
      return isValidReturnValue;
    }
    // wijmoInputMaskで自動付与されるアンダーバーとハイフンを取り除く
    const postcodeString = String(wjControl.value).replace(/_/g, '').replace(/-/g, '');
    if (!judgeBlank && (postcodeString === '' || postcodeString === null)) {
      return isValidReturnValue;
    }
  if (!REGEXP.POSTCODE_WITHOUT_HYPHEN.test(postcodeString)) {
      $('#' + attr).addClass('wj-postcode-invalid');
      this.msgServ.warning(MSG.WARNING.NOT_POSTCODE, '');
      this.validationInvalid = true;
      isValidReturnValue = false;
    } else {
      $('#' + attr).removeClass('wj-postcode-invalid');
    }
    return isValidReturnValue;
  }

  public isDuplicateTwoTerms(sourceFrom: Date, sourceTo: Date, targetFrom: Date, targetTo: Date, allowEqualDate: boolean = false): boolean {
    if (allowEqualDate) {
      if (targetFrom <= sourceTo && targetTo >= sourceFrom) {
        return true;
      }
    }
    if (!allowEqualDate) {
      if (targetFrom < sourceTo && targetTo > sourceFrom) {
        return true;
      }
    }
  }

  /** [wijmoフォーム専用] 指定期間が既存データの期間と重複していなければ許可 */
  public wDateNotDuplicate(
    attr1: string, attr2: string, wijmoStartDate: Date, wijmoEndDate: Date,
    grid: any, formLabel1: string, formLabel2: string
  ): boolean {
    let isValidReturnValue = true;
    if (wijmoStartDate === null || wijmoEndDate === null ) {
      return isValidReturnValue;
    }
    const wjStartDate = this.utilServ.uTime.setTime0InDate(wijmoStartDate);
    const wjEndDate = this.utilServ.uTime.setTime0InDate(wijmoEndDate);
    let isDuplicate = false;
    for (const record of grid.items) {
      const recordStartDate = this.utilServ.uTime.setTime0InDate(this.utilServ.uTime.toDate(record.start_date, '/'));
      const recordEndDate = this.utilServ.uTime.setTime0InDate(this.utilServ.uTime.toDate(record.end_date, '/'));

      if (recordEndDate < wjStartDate && recordStartDate < wjEndDate) {
      } else if (wjStartDate < recordEndDate && wjEndDate < recordStartDate) {
      } else {
        isDuplicate = true;
      }
    }
    if (isDuplicate === true) {
      $(attr1).addClass('wj-date-duplicate-invalid');
      $(attr2).addClass('wj-date-duplicate-invalid');
      this.msgServ.warning(MSG.WARNING.DATE_DUPLICATE(formLabel1, formLabel2), '');
      this.validationInvalid = true;
      isValidReturnValue = false;
    } else {
      $(attr1).removeClass('wj-date-duplicate-invalid');
      $(attr2).removeClass('wj-date-duplicate-invalid');
    }
    return isValidReturnValue;
  }

  /** 任意のフォームのFormControlに関連するinvalidClassを消す */
  public removeFormControlInvalidClass(id: string): void {
    $('#' + id).removeClass(
      'ng-invalid ng-dirty'
    );
  }

    /** [input-autocompleteフォーム専用] 空白以外を許可
   * @param {string} id テンプレート上のid名
   * @param {any} selected {label: string, value: any}
   * @param {string} formLabel formLabel。エラーメッセージに使用。
   * @returns {boolean} 結果がinvalidの場合、false
   */
  public autoCompRequireValidation(id: string, selected: {label: string, value: any}, formLabel: string): boolean {
    let isValidReturnValue = true;
    const ngModel = selected.value;

    if (ngModel === '' || ngModel === null || ngModel === -1) {
      $('#' + id).addClass('autocomplete-require-invalid');
      this.msgServ.warning(MSG.WARNING.BLANK(formLabel), '');

      this.validationInvalid = true;
      isValidReturnValue = false;
    } else {
      $('#' + id).removeClass('autocomplete-require-invalid');
    }
    return isValidReturnValue;
  }

  /** 任意のフォームのinput-autocompleteに関連するinvalidClassを消す */
  public removeInputAutoCompleteInvalidClass(id: string): void {
    $('#' + id).removeClass('autocomplete-require-invalid');
  }

  /** 半角カタカナを全角カタカナに変換 */
  public changeHalfWidthKATAKANAToFullWidth(str: string): string {
    if (!str) {
      return str;
    }

    let replaceFm = new Array(
      'ｳﾞ', 'ｶﾞ', 'ｷﾞ', 'ｸﾞ', 'ｹﾞ', 'ｺﾞ'
      , 'ｻﾞ', 'ｼﾞ', 'ｽﾞ', 'ｾﾞ', 'ｿﾞ'
      , 'ﾀﾞ', 'ﾁﾞ', 'ﾂﾞ', 'ﾃﾞ', 'ﾄﾞ'
      , 'ﾊﾞ', 'ﾋﾞ', 'ﾌﾞ', 'ﾍﾞ', 'ﾎﾞ'
      , 'ﾊﾟ', 'ﾋﾟ', 'ﾌﾟ', 'ﾍﾟ', 'ﾎﾟ'
    );
    let replaceTo = new Array(
      'ヴ', 'ガ', 'ギ', 'グ', 'ゲ', 'ゴ'
      , 'ザ', 'ジ', 'ズ', 'ゼ', 'ゾ'
      , 'ダ', 'ヂ', 'ヅ', 'デ', 'ド'
      , 'バ', 'ビ', 'ブ', 'ベ', 'ボ'
      , 'パ', 'ピ', 'プ', 'ペ', 'ポ'
    );
    for (const key of Object.keys(replaceFm)) {
      str = str.replace(new RegExp(replaceFm[key], 'g'), replaceTo[key]);
    }

    replaceFm = new Array(
        'ｱ', 'ｲ', 'ｳ', 'ｴ', 'ｵ'
        , 'ｶ', 'ｷ', 'ｸ', 'ｹ', 'ｺ'
        , 'ｻ', 'ｼ', 'ｽ', 'ｾ', 'ｿ'
        , 'ﾀ', 'ﾁ', 'ﾂ', 'ﾃ', 'ﾄ'
        , 'ﾅ', 'ﾆ', 'ﾇ', 'ﾈ', 'ﾉ'
        , 'ﾊ', 'ﾋ', 'ﾌ', 'ﾍ', 'ﾎ'
        , 'ﾏ', 'ﾐ', 'ﾑ', 'ﾒ', 'ﾓ'
        , 'ﾔ', 'ﾕ', 'ﾖ'
        , 'ﾗ', 'ﾘ', 'ﾙ', 'ﾚ', 'ﾛ'
        , 'ﾜ', 'ｦ', 'ﾝ'
        , 'ｧ', 'ｨ', 'ｩ', 'ｪ', 'ｫ'
        , 'ｬ', 'ｭ', 'ｮ', 'ｯ'
        , '､', '｡', 'ｰ', '｢', '｣', 'ﾞ', 'ﾟ'
    );
    replaceTo = new Array(
        'ア', 'イ', 'ウ', 'エ', 'オ'
        , 'カ', 'キ', 'ク', 'ケ', 'コ'
        , 'サ', 'シ', 'ス', 'セ', 'ソ'
        , 'タ', 'チ', 'ツ', 'テ', 'ト'
        , 'ナ', 'ニ', 'ヌ', 'ネ', 'ノ'
        , 'ハ', 'ヒ', 'フ', 'ヘ', 'ホ'
        , 'マ', 'ミ', 'ム', 'メ', 'モ'
        , 'ヤ', 'ユ', 'ヨ'
        , 'ラ', 'リ', 'ル', 'レ', 'ロ'
        , 'ワ', 'ヲ', 'ン'
        , 'ァ', 'ィ', 'ゥ', 'ェ', 'ォ'
        , 'ャ', 'ュ', 'ョ', 'ッ'
        , '、', '。', 'ー', '「', '」', '”', ''
    );
    for (const key of Object.keys(replaceFm)) {
        str = str.replace(new RegExp(replaceFm[key], 'g'), replaceTo[key]);
    }
    return str;
  }

  /**
 * 全角から半角への変革関数
 * 入力値の英数記号を半角変換して返却
 * [引数]   strVal: 入力値
 * [返却値] String(): 半角変換された文字列
 */
  public toHalfWidthAlphameric(str: any) {
    if (!str) {
      return str;
    }

    // 半角変換
    const halfWidthString = str.replace(/[！-～]/g,
      tmpStr => {
        // 文字コードをシフト
        return String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0);
      }
    );

    // 文字コードシフトで対応できない文字の変換
    return halfWidthString.replace(/”/g, "\"")
      .replace(/’/g, "'")
      .replace(/‘/g, "`")
      .replace(/￥/g, "\\")
      .replace(/　/g, " ")
      .replace(/〜/g, "~");
  }

  /** 日本語の文字列は空白文字に置き換える */
  replaceAllJapanese(str: string) {
    if (!str) {
      return str;
    }
    return str.replace(/./g,
      e => {
        if (e.match(/^[\u30a0-\u30ff\u3040-\u309f\u3005-\u3006\u30e0-\u9fcf]+$/g)) {
          return '';
        } else {
          return e;
        }
      }
    );
  }

  /** 日本語は除去し、全角を半角に自動変換 */
  removeJapaneseAndReplaceHalfWidth(str: string) {
    if (!str) {
      return str;
    }
    let string = str;
    string = this.replaceAllJapanese(string);
    string = this.toHalfWidthAlphameric(string);
    return string;
  }

  /** 数字以外の入力値は許可しない(数字専用入力input用) */
  allowInputOnlyNumber(inputEvent: any, formControl: FormControl) {
    // 入力値の型チェック
    if (inputEvent && inputEvent.data) {
      const isNumberOrHyphen = inputEvent.data.match(/^[0-9\-]+$/);
      if (!isNumberOrHyphen) {
        formControl.setValue(0);
      }
    }
  }

  /** 数字以外の値は保持しない(数字専用入力input用) */
  allowHoldOnlyNumber(formControl: FormControl, minLength: number = null, maxLength: number = null) {
    // validation
    if (minLength !== null && Number(formControl.value) < minLength) {
      formControl.setValue(minLength);
    }
    if (maxLength !== null && Number(formControl.value) > maxLength) {
      formControl.setValue(maxLength);
    }
    // 0詰め、途中のハイフン挿入対策
    if (isNaN(Number(formControl.value))) {
      formControl.setValue(0);
    } else {
      formControl.setValue(Number(formControl.value));
    }
  }

  /** cognitoのパスワードポリシーにあった文字列か検証
   * @param formControl formControl
   * @returns 検証結果
   */
  public cognitoPassValidation(formControl: any): boolean {
    let isValidReturnValue = true;
    if (!this.isCognitoPassword(formControl.value)) {
      formControl.status = 'INVALID';
      this.msgServ.warning(MSG.WARNING.INVALID_PASSWORD, '');
      this.validationInvalid = true;
      isValidReturnValue = false;
    }
    return isValidReturnValue;
  }

  /** cognitoのパスワードポリシーチェック
   * @param str パスワード文字列
   * @returns strが8文字以上かつ大文字・小文字・数字がそれぞれ1文字以上含まれていればtrue
   */
  private isCognitoPassword(str: string): boolean {
    if (!str || typeof(str) !== 'string') {
      return;
    }
    let result = true;

    if (str.length < 8 || !str.match(/\d/) || !str.match(/[a-z]/) || !str.match(/[A-Z]/) || str.match(/\?/) || str.match(/\//) || str.match(/&/)) {
      result = false;
    }
    return result;
  }

  /** 献立CDに指定できない文字列(接頭辞の"regi-", "auto-")が入っていないかを検証。入っていた場合はその文字列を除去してreturn。
   * @param str 献立CD
   */
  public checkKonCode(str: string): string {
    if (!str || typeof(str) !== 'string') {
      return '';
    }

    if (/^regi-/g.test(str)) {
      str = str.replace('regi-', '');
    }

    return str;
  }
}

